<template>
  <div class="navbar" :class="[navbarFixed ? 'navBarWrap' :'', routeType === '/index' ? '' : 'navChild']">
    <div class="navbarTab">
      <div class="nav">
        <div class="tab" v-for="route in routerList" :key="route.link" @click="checkRoute(route)">
          <router-link :to="route.link" :style="{color: route.type === routeType && routeType != '/index' ? '#226cdc' : ''}">{{ route.title }}</router-link>
        </div>
      </div>
      <div class="login">
        <div v-if="!userName">
          <span @click="login" :style="{'color': routeType != '/index' ? '#000' : '#fff'}">登录</span>
          <span @click="login" :style="{'color': routeType != '/index' ? '#000' : '#fff'}">注册</span>
        </div>
        <div v-else>
          <span :style="{'color': routeType === '/index' ? '#fff' : '#000'}">{{ userName }}</span>
          <span><router-link to="/personcenter" :style="{'color': routeType === '/index' ? '#fff' : '#000'}">用户中心</router-link></span>
          <span :style="{'color': routeType === '/index' ? '#fff' : '#000'}" @click="logout">退出</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { removeToken, removeApplyToken,removeAdminToken } from '@/utils/auth'
export default {
  name: "Navbar",
  data() {
    return {
      navbarFixed: false,
      routerList: [
        {
          link: '/index',
          title: '首页',
          type: 'index'
        },
        {
          link: '/publish',
          title: '政策中心'
        },
        {
          link: '/cashapply',
          title: '兑现申报'
        },
        {
          link: '/msjx',
          title: '免申即享'
        }
      ],
      routeType: '/index'
    }
  },
  watch: {
    '$route': {
      handler: function (to, from) {
        if (to.path == '/personcenter/wdbj') {
          this.routeType = '/index';
        }
      },
      deep: true
    }
  },
  computed: {
    userName() {
      return this.$store.state.user.userInfo.companyName
    }
  },
  mounted () {
    window.addEventListener('scroll', this.watchScroll, true)
  },
  methods: {
    checkRoute(route) {
      this.routeType = route.type = route.link;
    },
    watchScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 60) {
        this.navbarFixed = true;
      } else {
        this.navbarFixed = false;
      }
    }, 
    goPath(path) {
      this.$router.push(path);
    },
    login() {
        if(process.env.VUE_APP_BASE_OUT.indexOf('ceshi')>-1){
            console.log('555',window.location.href)
            window.open(`https://tysfrzcs.tj.gov.cn/sso/login?client_id=28MQP84DT&utype=0&goto=http://60.29.39.171:8090/ceshi/index`, '_self')
        }else{
            window.open(`https://tysfrzcs.tj.gov.cn/sso/login?client_id=N7S4UXW1J&utype=0&goto=http://60.29.39.171:8090/index`, '_self')
        }
    },
    logout() {
      this.$store.commit('SetName', '');
      this.$store.commit('SetUserInfo', {});
      removeToken();
      removeApplyToken();
      removeAdminToken();
      window.open(process.env.VUE_APP_BASE_OUT, '_self');
    //    if(process.env.VUE_APP_BASE_OUT.indexOf('ceshi')>-1){
    //         window.open(`https://tysfrzcs.tj.gov.cn/sso/logout?client_id=28MQP84DT&utype=0&goto=http://60.29.39.171:8090/ceshi/index`, '_self')
    //     }else{
    //         window.open(`https://tysfrzcs.tj.gov.cn/sso/logout?client_id=N7S4UXW1J&utype=0&goto=http://60.29.39.171:8090/index`, '_self')
    //     } 
    },
    goPersonCenter() {
      this.$router.push('/personcenter')
    }
  }
}
</script>

<style lang="scss" scoped>
.navBarWrap {
  position:fixed;
  top:0;
  z-index:999;
}


.navbar {
  width: 100%;
  height: 70px;
  background-color: #226cdc;

  .navbarTab {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .tab {
      color: #fff;
      font-size: 20px;
      display: inline-block;

      & a {
        color: #fff;
      }
    }
    .tab + .tab {
      margin-left: 55px;
    }
    
    .login {
      display: flex;
      align-items: center;

      span {
        font-size: 14px;
        color: #fff;
        cursor: pointer;
      }

      span + span {
        margin-left: 8px;
      }

      a {
        color: #fff;
      }
    }
  }
}

.navChild {
  background-color: #fff;
  border-bottom: 2px solid #226cdc;

  .navbarTab {
    .tab {
      color: #000;
      font-size: 20px;
      font-weight: bold;
      display: inline-block;

      & a {
        color: #000;
      }
    }
  }
  
}
</style>